import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { BadgeCheckIcon } from 'lucide-react';
const buyers = [{
  name: 'María G.',
  location: 'Ciudad de México'
}, {
  name: 'Julián L.',
  location: 'Bogotá'
}, {
  name: 'Carolina P.',
  location: 'Guadalajara'
}, {
  name: 'Ricardo A.',
  location: 'Lima'
}, {
  name: 'Florencia B.',
  location: 'Santiago'
}, {
  name: 'Agustina S.',
  location: 'Buenos Aires'
}];
export function FloatingNotification() {
  const [isVisible, setIsVisible] = useState(false);
  const [buyerIndex, setBuyerIndex] = useState(0);
  const reduceMotion = useReducedMotion();
  const buyer = buyers[buyerIndex];
  useEffect(() => {
    const openTimer = window.setTimeout(() => setIsVisible(true), 4500);
    const interval = window.setInterval(() => {
      setIsVisible(false);
      window.setTimeout(() => {
        setBuyerIndex(current => (current + 1) % buyers.length);
        setIsVisible(true);
      }, 800);
    }, 30000);
    return () => {
      window.clearTimeout(openTimer);
      window.clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-65" data-mp="1qxnwyl0fs472">
      {isVisible && <motion.aside initial={reduceMotion ? false : {
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={reduceMotion ? undefined : {
      opacity: 0,
      y: 10
    }} transition={{
      duration: 0.25,
      ease: [0.22, 1, 0.36, 1]
    }} aria-live="polite" className="fixed bottom-4 left-4 z-50 max-w-[calc(100vw-2rem)] md:bottom-7 md:left-7" data-id="element-66" data-mp="1qwcr8fnfkmdb">
          <div className="paper-card flex gap-3 rounded-sm border border-brand-gold/45 p-4 shadow-xl" data-id="element-67" data-mp="u8q08x94lw79">
            <span className="mt-0.5 rounded-sm bg-brand-greenSage p-2" data-id="element-68" data-mp="kj9kv1jl1x4r">
              <BadgeCheckIcon className="h-5 w-5 text-brand-forest" aria-hidden="true" data-id="element-69" data-mp="om5y0cqct11b" />
            </span>
            <div data-id="element-70" data-mp="anpu0tjvlomv">
              <p className="text-xs text-brand-muted" data-id="element-71" data-mp="ao7szxxxagyh">
                Compra verificada · hace unos minutos
              </p>
              <p className="mt-1 text-sm text-brand-text" data-id="element-72" data-mp="13a0s9xk0fdgi">
                <strong data-id="element-73" data-mp="13cn78i98cv8r">{buyer.name}</strong> de {buyer.location} compró
              </p>
              <p className="mt-1 text-sm font-bold text-brand-forest" data-id="element-74" data-mp="188u31i7wwqcz">
                Atlas Ancestral de Acupuntura™
              </p>
            </div>
          </div>
        </motion.aside>}
    </AnimatePresence>;
}